import * as React from 'react';

// `stroke` and the dimensions are props so a caller can match its own design
// without a second copy of the glyph. Defaults are the original 32px /
// #8B8AA8 the sidebar and user menu were built against, so those two are
// unchanged; the profile (HORO-10533) passes white at 22px per Figma.
const LogoutIcon = ({ width = 32, height = 32, stroke = '#8B8AA8', ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none" {...props}>
        <path
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 28H6.667A2.667 2.667 0 0 1 4 25.333V6.667A2.667 2.667 0 0 1 6.667 4H12M21.334 22.666 28.001 16l-6.667-6.667M28 16H12"
        />
    </svg>
);
export default LogoutIcon;
